import { Helmet } from "react-helmet-async";
import { Reveal } from "../components/Reveal";
import MagneticButton from "../components/MagneticButton";
import EventCalendarWidget from "../components/EventCalendarWidget";
import { Link } from "react-router-dom";

export default function OpenClasses() {
  return (
    <>
      <Helmet>
        <title>Open Classes — Monthly Cooking & Cocktail Workshops in Tucson | Salumi Tucson</title>
        <meta name="description" content="Once-a-month open cooking classes in Tucson, Arizona. Seasonal, themed, hands-on classes hosted at venues around town. View the upcoming Salumi Tucson open class schedule." />
        <link rel="canonical" href="https://salumitucson.com/classes" />
      </Helmet>

      <section className="bg-sand text-espresso pt-40 md:pt-56 pb-24" data-testid="classes-hero">
        <div className="max-w-[1480px] mx-auto px-6 md:px-10">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.3em] text-olive mb-6">A monthly calendar</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl tracking-editorial leading-[0.9]">
              Open <em className="not-italic text-terracotta">classes</em>
            </h1>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-12 max-w-2xl text-lg text-espresso/75 leading-relaxed">
              Once a month we hold an open class. No two classes are the same. Open classes are often themed and have a focus on seasonal dishes and drinks. These classes are a fun way to learn some new culinary skills while also meeting new people. We host open classes in various locations around Tucson, although we try to keep them fairly central. Open classes vary in price depending on where we are hosting and what we will be making. Please reach out if you have any questions.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory text-espresso py-24 md:py-32" data-testid="classes-schedule-section">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <Reveal>
            <div className="flex items-end justify-between border-b border-espresso/15 pb-6 mb-12">
              <h2 className="font-serif text-4xl md:text-6xl tracking-editorial">Schedule</h2>
              <p className="text-[11px] uppercase tracking-[0.3em] text-olive">Updated monthly</p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <EventCalendarWidget />
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-20 text-center">
              <p className="text-base md:text-lg text-espresso/70 leading-relaxed max-w-xl mx-auto mb-8">
                Want to reserve a seat or have a question about an upcoming class? Send us a note — we'd love to hear from you.
              </p>
              <Link to="/private-bookings#contact" data-testid="classes-contact-cta">
                <MagneticButton variant="espresso" as="span">
                  Get in touch
                </MagneticButton>
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
